import { Card, CardContent } from "./ui/card";
import { Users, Shield, Church, Heart } from "lucide-react";

/**
 * 7-card stats grid on the admin Overview tab. Pure presentation.
 */
export function AdminStatsOverview({ stats }) {
  const items = [
    { label: "Total Users",     value: stats?.users,             icon: Users,  color: "text-blue-600",   bg: "bg-blue-50" },
    { label: "Admins",          value: stats?.admins,            icon: Shield, color: "text-purple-600", bg: "bg-purple-50" },
    { label: "Churches",        value: stats?.churches,          icon: Church, color: "text-sage",       bg: "bg-sage/10" },
    { label: "Groups",          value: stats?.groups,            icon: Heart,  color: "text-rose-600",   bg: "bg-rose-50" },
    { label: "Total Prayers",   value: stats?.prayers,           icon: Heart,  color: "text-amber-600",  bg: "bg-amber-50" },
    { label: "Active Prayers",  value: stats?.active_prayers,    icon: Heart,  color: "text-orange-600", bg: "bg-orange-50" },
    { label: "Answered",        value: stats?.answered_prayers,  icon: Heart,  color: "text-green-600",  bg: "bg-green-50" },
  ];
  return (
    <>
      <h2 className="font-serif text-2xl font-semibold text-stone-dark mb-6" data-testid="admin-overview-title">
        Site Overview
      </h2>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-8">
        {items.map((s) => {
          const Icon = s.icon;
          return (
            <Card
              key={s.label}
              className="border-stone"
              data-testid={`stat-${s.label.toLowerCase().replace(/ /g, "-")}`}
            >
              <CardContent className="p-4 flex items-center gap-3">
                <div className={`w-10 h-10 rounded-xl ${s.bg} flex items-center justify-center`}>
                  <Icon className={`w-5 h-5 ${s.color}`} />
                </div>
                <div>
                  <p className="text-2xl font-semibold text-stone-dark">{s.value ?? 0}</p>
                  <p className="text-xs text-stone-dark/50">{s.label}</p>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </>
  );
}
